import React, {Suspense, lazy } from 'react';
import './App.css';
import PrivateRoute from './components/PrivateRoutes/PrivateRoutes';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
//import Addtomanifestp from './components/chatbotportal/pages/addtomanifest';

//import Logincbt from './components/mainpage/pages/Login';
const Logincbt = lazy(() => import('./components/mainpage/pages/Login'))
//import Addusersp from './components/chatbotportal/pages/addusers';
const Addusersp = lazy(() => import('./components/chatbotportal/pages/addusers'))
//import Uploadassignments from './components/chatbotportal/pages/uploadassignment';
const Uploadassignments = lazy(() => import('./components/chatbotportal/pages/uploadassignment'))
//import Schedulerpage from './components/chatbotportal/pages/scheduler';
const Schedulerpage = lazy(() => import('./components/chatbotportal/pages/scheduler'))
//import Addgroupp from './components/chatbotportal/pages/groups';
const Addgroupp = lazy(() => import('./components/chatbotportal/pages/groups'))
//import Studentreportp from './components/chatbotportal/pages/studentreport';
const Studentreportp = lazy(() => import('./components/chatbotportal/pages/studentreport'))
//import Payslip from './components/chatbotportal/pages/payslips';
const Payslip = lazy(() => import('./components/chatbotportal/pages/payslips'))
//import Uploadtimetables from './components/chatbotportal/pages/uploadtimetable';
const Uploadtimetables = lazy(() => import('./components/chatbotportal/pages/uploadtimetable'))
//import Uploadnotespage from './components/chatbotportal/pages/uploadnotes';
const Uploadnotespage = lazy(() => import('./components/chatbotportal/pages/uploadnotes'))
//import Uploadannouncementpage from './components/chatbotportal/pages/announcement';
const Uploadannouncementpage = lazy(() => import('./components/chatbotportal/pages/announcement'))
//import Uploadeventspage from './components/chatbotportal/pages/events';
const Uploadeventspage = lazy(() => import('./components/chatbotportal/pages/events'))
///import Enquirypage from './components/chatbotportal/pages/enquiry';
const Enquirypage = lazy(() => import('./components/chatbotportal/pages/enquiry'))

const Travelersmanifest = lazy(() => import('./components/chatbotportal/pages/uploadmanifest'))

const Sendstartmessage = lazy(() => import('./components/chatbotportal/pages/sendstartmessage'))

const Triviaoffset= lazy(() => import('./components/chatbotportal/pages/triviaoffset'))

const Scanticket = lazy(() => import('./components/chatbotportal/pages/scanticket'))

const Manifest = lazy(() => import('./components/chatbotportal/pages/manifest'))

const Addtomanifestp = lazy(() => import('./components/chatbotportal/pages/addtomanifest'))

const Addbulktomanifestp = lazy(() => import('./components/chatbotportal/pages/addbulktomanifest'))

const Circulation = lazy(() => import('./components/chatbotportal/pages/circulation'))

const Newaddmemberp = lazy(() => import('./components/chatbotportal/pages/newaddmembers'))

const Borrowhistory = lazy(() => import('./components/chatbotportal/pages/borrowhistory'))

const CirculationDashboardp = lazy(() => import('./components/chatbotportal/pages/circulationdashboard'))

const Lostbook = lazy(() => import('./components/chatbotportal/pages/lostbook'))

const BookDashboardp = lazy(() => import('./components/chatbotportal/pages/bookdashboard'))

const Newbulkbooks= lazy(() => import('./components/chatbotportal/pages/newbulkbooks'))

const Newbulkstudents = lazy(() => import('./components/chatbotportal/pages/newbulkstudents'))

const App = () => {
    return (
       <>
        <Router>
            <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                    <Route path='/' element={<Logincbt />} />

                   

                    <Route path='/addmembers' element={
                        <PrivateRoute element={<Newaddmemberp />} role={['itstaff','staff', 'admin']} />
                    } />

                    <Route path='/circulation' element={
                        <PrivateRoute element={<Circulation />} role={['itstaff','staff', 'admin']} />
                    } />
                    
                    <Route path='/circulationdashboard' element={
                        <PrivateRoute element={<CirculationDashboardp />} role={['itstaff','staff', 'admin']} />
                    } />
                    

                    <Route path='/lostbook' element={
                        <PrivateRoute element={<Lostbook />} role={['itstaff','admin']} />
                    } />

                    <Route path='/bookdashboard' element={
                        <PrivateRoute element={<BookDashboardp />} role={['itstaff','admin']} />
                    } />
                    
                     <Route path='/borrowhistory' element={
                        <PrivateRoute element={<Borrowhistory />} role={['itstaff','staff', 'admin']} />
                    } />

                
                    <Route path='/lendbook' element={
                        <PrivateRoute element={<Scanticket />} role={['itstaff','staff', 'admin']} />
                    } />

                    <Route path='/addbooks' element={
                        <PrivateRoute element={<Manifest />} role={['itstaff','admin']} />
                    } />

                    <Route path='/addbulktomanifest' element={
                        <PrivateRoute element={<Addbulktomanifestp />} role={['itstaff', 'admin']} />
                    } />

                    <Route path='/newbulkbooks' element={
                        <PrivateRoute element={<Newbulkbooks />} role={['itstaff', 'admin']} />
                    } />

                    <Route path='/newbulkstudents' element={
                        <PrivateRoute element={<Newbulkstudents />} role={['itstaff', 'admin']} />
                    } />    



                </Routes>
            </Suspense>   
        </Router>
       </>
    )
}

export default App;


/*
 <Route path='/addusers' element={
                        <PrivateRoute element={<Addusersp />} role={['itstaff','staff']} />
                    } />

                     <Route path='/uploadassignment' element={
                        <PrivateRoute element={<Uploadassignments />} role={['itstaff','staff']} />
                    } />

                    <Route path='/scheduler' element={
                        <PrivateRoute element={<Schedulerpage />} role={['itstaff','staff']} />
                    } />

                      <Route path='/studentreport' element={
                        <PrivateRoute element={<Studentreportp />} role={['itstaff','staff']} />
                    } />

                      <Route path='/payslip' element={
                        <PrivateRoute element={<Payslip />} role={['itstaff','staff']} />
                    } />

                    <Route path='/uploadtimetable' element={
                        <PrivateRoute element={<Uploadtimetables />} role={['itstaff','staff']} />
                    } />

                    <Route path='/uploadnotes' element={
                        <PrivateRoute element={<Uploadnotespage />} role={['itstaff','staff']} />
                    } />

                    <Route path='/uploadannouncements' element={
                        <PrivateRoute element={<Uploadannouncementpage />} role={['itstaff','staff']} />
                    } />

                    <Route path='/uploadevents' element={
                        <PrivateRoute element={<Uploadeventspage />} role={['itstaff','staff']} />
                    } />

                    <Route path='/enquiry' element={
                        <PrivateRoute element={<Enquirypage />} role={['itstaff','staff']} />
                    } />

                    <Route path='/addmanifest' element={
                        <PrivateRoute element={<Travelersmanifest />} role={['itstaff','staff']} />
                    } />

                    <Route path='/sendstartmessage' element={
                        <PrivateRoute element={<Sendstartmessage />} role={['itstaff','staff']} />
                    } />

                    <Route path='/triviaoffset' element={
                        <PrivateRoute element={<Triviaoffset />} role={['itstaff','staff']} />
                    } />

                      <Route path='/addtomanifest' element={
                        <PrivateRoute element={<Addtomanifestp />} role={['itstaff','staff']} />
                    } />



*/

